import { forwardRef } from 'react';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { Button, IconButton } from '@material-ui/core';
import { CloseRounded } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';

export default function Notifications() {
    return (
        <SnackbarProvider
            anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
            maxSnack={1}
            Components={{
                success: AlertComponent('success'),
                error: AlertComponent('error'),
                warning: AlertComponent('warning'),
                info: AlertComponent('info'),
                default: AlertComponent('info')
            }}
        />
    );
}

function SnackbarActions({ snackbarKey, primaryAction }) {
    const { closeSnackbar } = useSnackbar();

    return (
        <>
            {primaryAction ? (
                <Button
                    onClick={() => {
                        closeSnackbar(snackbarKey);
                        primaryAction.onClick();
                    }}
                    color='inherit'
                    size='small'
                >
                    {primaryAction.label}
                </Button>
            ) : null}
            <IconButton onClick={() => closeSnackbar(snackbarKey)} size='small' color='inherit'>
                <CloseRounded fontSize='small' />
            </IconButton>
        </>
    );
}

const AlertComponent = severity =>
    forwardRef((props, ref) => {
        const { message, snackbarKey, primaryAction } = props;

        return (
            <Alert
                ref={ref}
                variant='standard'
                severity={severity}
                action={<SnackbarActions snackbarKey={snackbarKey} primaryAction={primaryAction} />}
            >
                {message}
            </Alert>
        );
    });
